// extracted by mini-css-extract-plugin
export default {"tabs":"AuditionDetailTabs_tabs__4Qbgf","tab":"AuditionDetailTabs_tab__05QvD","active":"AuditionDetailTabs_active__UDthF"};